<template>
  <v-app-bar
  
    height="80"
    app
    color="white"
    elevate-on-scroll
    flat
    class="modern-header"
  >
    <!-- Left: Logo -->
    <v-toolbar-title style="padding-left: 50px" class="logo" @click="goToHome">
      <v-img
        src="@/assets/icons/OhYesMainLogo.png"
        alt="OH.YES Logo"
        contain
        height="52"
        width="140"
      />
    </v-toolbar-title>

    <v-spacer />

    <!-- ================= DESKTOP NAV ================= -->
    <div class="d-none d-md-flex nav-links">
      <router-link
        v-for="item in menuItems"
        :key="item.title"
        :to="item.path"
        class="nav-link"
        exact
        :class="{ active: $route.path === item.path }"
      >
        {{ item.title }}
      </router-link>

      <!-- Desktop Account -->
      <div v-if="isLoggedIn" class="account-section">
        <v-btn
          text
          small
          color="#000"
          class="my-bookings-btn mx-2"
          @click="$router.push('/bookings')"
        >
          <v-icon left small>mdi-calendar-text</v-icon>
          My Bookings
        </v-btn>

        <v-menu offset-y bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="account-trigger ml-2" v-bind="attrs" v-on="on">
              <v-icon size="22">mdi-account-circle</v-icon>
              <span class="user-mobile-text">{{ maskedMobileNumber }}</span>
              <v-icon size="18">mdi-chevron-down</v-icon>
            </div>
          </template>

          <v-card class="pa-2 d-flex flex-column" min-width="150">
            <v-chip
              small
              outlined
              color="red"
              class="logout-chip justify-center"
              @click="logout"
            >
              <v-icon left small>mdi-logout</v-icon>
              Logout
            </v-chip>
          </v-card>
        </v-menu>
      </div>
    </div>

    <!-- ================= MOBILE ACCOUNT ICON ================= -->
    <div v-if="isLoggedIn" class="d-flex d-md-none mr-2 align-center">
      <v-btn
        icon
        small
        color="#000"
        class="mr-2"
        @click="$router.push('/bookings')"
      >
        <v-icon size="20">mdi-calendar-text</v-icon>
      </v-btn>

      <v-menu offset-y bottom>
        <template v-slot:activator="{ on, attrs }">
          <div class="mobile-account-trigger" v-bind="attrs" v-on="on">
            <v-icon size="24" color="#000">mdi-account-circle</v-icon>
            <span class="user-mobile-text mobile-only">{{ maskedMobileNumber }}</span>
          </div>
        </template>

        <v-card class="pa-2 d-flex flex-column" min-width="120">
          <v-chip
            small
            outlined
            color="red"
            class="logout-chip justify-center"
            @click="logout"
          >
            <v-icon left small>mdi-logout</v-icon>
            Logout
          </v-chip>
        </v-card>
      </v-menu>
    </div>

    <!-- Mobile Menu Icon -->
    <v-app-bar-nav-icon
      class="d-md-none"
      color="#000"
      @click.stop="drawer = true"
    />

    <!-- ================= MOBILE DRAWER ================= -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      right
      color="#fff"
      overlay
    >
      <div class="pa-4 d-flex align-center justify-space-between">
        <div class="text-h6" style="font-weight: 700; color: #000">Menu</div>
        <v-btn icon @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-divider />

      <v-list dense>
        <router-link
          v-for="item in menuItems"
          :key="item.title"
          :to="item.path"
          exact
          class="drawer-link"
          @click.native="closeDrawerOnNav"
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title style="color: #000; font-weight: 600">
                {{ item.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>

        <v-list-item
          v-if="isLoggedIn"
          @click="$router.push('/bookings'); drawer = false"
        >
          <v-list-item-icon class="mr-3">
            <v-icon color="#000">mdi-calendar-text</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title style="color: #000; font-weight: 600">
              My Bookings
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="my-4" />

      <div class="px-4">
        <router-link
          style="text-decoration: none"
          :to="`${basePath}/contact`"
          @click.native="closeDrawerOnNav"
        >
          <v-btn block color="#ff6b35" dark rounded elevation="2">
            Register as Partner
          </v-btn>
        </router-link>
      </div>
    </v-navigation-drawer>
  </v-app-bar>
</template>

<script>
export default {
  name: "HeaderPage",

  data() {
    return {
      drawer: false,
      authTrigger: 0,
    };
  },

  computed: {
    isLoggedIn() {
      // eslint-disable-next-line no-unused-expressions
      this.authTrigger;
      return !!localStorage.getItem("access_token");
    },

    maskedMobileNumber() {
      // eslint-disable-next-line no-unused-expressions
      this.authTrigger;
      const number = localStorage.getItem("mobile_number");
      if (!number) return "";
      
      if (number.length <= 4) return number;
      
      return (
        number.slice(0, 2) + 
        "*".repeat(Math.max(1, number.length - 4)) + 
        number.slice(-2)
      );
    },

    isUS() {
      return (
        this.$route.meta?.location === "us" ||
        localStorage.getItem("isUS") === "true"
      );
    },

    basePath() {
      return this.isUS ? "/us" : "";
    },

    menuItems() {
      return [
        { title: "Home", path: this.isUS ? "/us" : "/" },
        { title: "About", path: `${this.basePath}/about` },
        { title: "Services", path: `${this.basePath}/services` },
        { title: "Blog", path: "/blog" },
        { title: "News", path: `${this.basePath}/news` },
      ];
    },
  },

  watch: {
    $route() {
      this.drawer = false;
    },
  },

  mounted() {
    this.$bus.$on("auth-change", () => {
      this.authTrigger++;
    });
  },

  beforeDestroy() {
    this.$bus.$off("auth-change");
  },

  methods: {
    goToHome() {
      this.$router.push(this.isUS ? "/us" : "/");
    },

    closeDrawerOnNav() {
      this.$nextTick(() => (this.drawer = false));
    },

    logout() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("mobile_number");
      localStorage.removeItem("is_registered");
      localStorage.removeItem("authRegion");

      this.$bus.$emit("auth-change");
      this.$router.push(this.isUS ? "/us" : "/");
    },
  },
};
</script>

<style scoped>
.modern-header {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 5 !important;
}

.logo {
  cursor: pointer;
}

.nav-links {
  display: flex;
  gap: 40px;
  align-items: center;
}

.nav-link {
  font-size: 15px;
  color: #000;
  text-decoration: none;
  font-weight: 700;
  position: relative;
  transition: opacity 0.25s ease;
}

.nav-link:hover {
  opacity: 0.7;
}

.nav-link.active::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 0;
  right: 0;
  height: 2px;
  background: #ff6b35;
}

.drawer-link {
  text-decoration: none;
  display: block;
}

.account-section {
  display: flex;
  align-items: center;
  margin-left: 20px;
  border-left: 1px solid rgba(0,0,0,0.1);
  padding-left: 10px;
}

.account-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-weight: 600;
  color: #000;
  padding: 4px 8px;
  border-radius: 20px;
  transition: background 0.2s;
}

.account-trigger:hover {
  background: rgba(0, 0, 0, 0.05);
}

.my-bookings-btn {
  font-weight: 700 !important;
  text-transform: none !important;
}

.user-mobile-text {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}

.mobile-account-trigger {
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
}

@media (max-width: 600px) {
  .user-mobile-text.mobile-only {
    font-size: 12px;
  }
}

.logout-chip {
  cursor: pointer;
}
</style>
